import en from '@fleetspoke/ui/i18n/en.json';
import ms from '@fleetspoke/ui/i18n/ms.json';
import zh from '@fleetspoke/ui/i18n/zh.json';
import { LANGUAGES, type Language } from '@fleetspoke/ui/tokens';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const STORAGE_KEY = 'fsa.language';

export function storedLanguage(): Language {
  const saved = typeof localStorage === 'undefined' ? null : localStorage.getItem(STORAGE_KEY);
  if (saved && (LANGUAGES as readonly string[]).includes(saved)) return saved as Language;
  const nav = typeof navigator === 'undefined' ? '' : navigator.language.toLowerCase();
  if (nav.startsWith('ms')) return 'ms';
  if (nav.startsWith('zh')) return 'zh';
  return 'en';
}

export function setLanguage(language: Language): void {
  localStorage.setItem(STORAGE_KEY, language);
  void i18n.changeLanguage(language);
  document.documentElement.lang = language === 'zh' ? 'zh-Hans' : language;
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ms: { translation: ms }, zh: { translation: zh } },
  lng: storedLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false }, // React escapes
  returnNull: false,
});

export default i18n;
